import owd from 'owd/owd';

export default class Preloader extends owd.Component {
    init() {
        this.bind();
    }

    bind() {
        if ($('html').hasClass('is-loaded')) {
            setTimeout(() => {
                this.$element.remove();
            }, 300);
        }
    }

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('preloader', {
    component: Preloader
});
